<template>
  <span
    class="Apptooltip"
    v-tooltip="{
      content: tooltip,
      triggers: ['click', 'hover', 'focus'],
      placement: 'top',
    }"
  >
    <app-icon name="info_outline" />
  </span>
</template>

<script setup>
  const props = defineProps({
    tooltip: {
        type: String,
        default: ''
      }
  });
</script>

<style lang="scss">
  .Apptooltip {
    display: inline-block;
    line-height: 1;
    margin: .02rem .08rem 0;
    cursor: pointer;

    .icon-info_outline {
      color: $primary;
    }
  }

  .v-popper__popper {
    .v-popper__inner {
      max-width: 300px;
      padding: .1rem;
      font-size: .14rem;
    }
  }
</style>
